"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSearchBoxHelp = void 0;
var tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/camelcase */
var react_1 = tslib_1.__importStar(require("react"));
var i18n_1 = require("../i18n");
var table_1 = require("../table");
var text_1 = require("../text");
// eslint-disable-next-line import/no-cycle
var TagSearchBox_1 = require("./TagSearchBox");
var zh_CN = {
    columns: {
        type: "",
        format: "输入格式",
        example: "示例",
        displayValue: "搜索框展示",
        description: "说明",
    },
    width: {
        type: 84,
        format: 168,
        example: 160,
        displayValue: 232,
        description: "auto",
    },
    rows: [
        {
            type: "单个关键字",
            format: "[关键字]",
            example: "10.0.0.1",
            displayValue: [
                {
                    attr: null,
                    values: [{ name: "10.0.0.1" }],
                },
            ],
            description: '过滤包含 "10.0.0.1" 关键字的实例',
        },
        {
            type: "多个关键字",
            format: "[关键字][回车↵][关键字]",
            example: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "\u9ED8\u8BA4\u9879\u76EE"),
                react_1.default.createElement("p", null, "www.123.com"),
                react_1.default.createElement("p", null, "192.169.23.54"))),
            displayValue: [
                {
                    attr: null,
                    values: [{ name: "默认项目" }],
                },
                {
                    attr: null,
                    values: [{ name: "www.123.com" }],
                },
                {
                    attr: null,
                    values: [{ name: "192.169.23.54" }],
                },
            ],
            description: '过滤同时包含 "默认项目" "www.123.com" 及 "192.169.23.54" 关键字的实例',
        },
        {
            type: "单资源属性",
            format: "[资源属性]:[关键字]",
            example: "IP:10.0.0.1",
            displayValue: [
                {
                    attr: {
                        key: "1",
                        type: "input",
                        name: "IP",
                    },
                    values: [{ name: "10.0.0.1" }],
                },
            ],
            description: '过滤 "IP" 为 "10.0.0.1" 的实例',
        },
        {
            type: "多资源属性",
            format: "[资源属性]:[关键字][回车↵][资源属性]:[关键字]",
            example: "可用区:广州一区 ↵ 所属项目:默认项目",
            displayValue: [
                {
                    attr: {
                        key: "1",
                        type: "input",
                        name: "可用区",
                    },
                    values: [{ name: "广州一区" }],
                },
                {
                    attr: {
                        key: "2",
                        type: "input",
                        name: "所属项目",
                    },
                    values: [{ name: "默认项目" }],
                },
            ],
            description: '过滤 "可用区" 为 "广州一区" 且 "所属项目" 为 "默认项目" 的实例',
        },
        {
            type: "单资源属性多关键字",
            format: "[资源属性]:[关键字]|[关键字]",
            example: "可用区:广州一区|广州二区",
            displayValue: [
                {
                    attr: {
                        key: "1",
                        type: "input",
                        name: "可用区",
                    },
                    values: [{ name: "广州一区" }, { name: "广州二区" }],
                },
            ],
            description: '过滤 "可用区" 为 "广州一区" 或 "广州二区" 的实例',
        },
        {
            type: "粘贴内容",
            format: "{使用换行、逗号、竖线分隔的内容粘入自动切分为多个关键字}",
            example: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "10.0.0.2"),
                react_1.default.createElement("p", null, "10.0.0.3"),
                react_1.default.createElement("p", null, "10.0.0.4"))),
            displayValue: [
                {
                    attr: null,
                    values: [
                        { name: "10.0.0.2" },
                        { name: "10.0.0.3" },
                        { name: "10.0.0.4" },
                    ],
                },
            ],
            description: '过滤包含 "10.0.0.2" 或 "10.0.0.3" 或 "10.0.0.4" 关键字的实例',
        },
    ],
};
var en_US = {
    columns: {
        type: "",
        format: "Enter Format",
        example: "Example",
        displayValue: "Display in Search Box",
        description: "Description",
    },
    width: {
        type: 84,
        format: 168,
        example: 168,
        displayValue: 232,
        description: "auto",
    },
    rows: [
        {
            type: "Single keyword",
            format: "[Keyword]",
            example: "10.0.0.1",
            displayValue: [
                {
                    attr: null,
                    values: [{ name: "10.0.0.1" }],
                },
            ],
            description: 'List all instances including the keyword "10.0.0.1"',
        },
        {
            type: "Multiple keywords",
            format: "[Keyword][Enter↵][Keyword]",
            example: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "web"),
                react_1.default.createElement("p", null, "www.123.com"),
                react_1.default.createElement("p", null, "192.169.23.54"))),
            displayValue: [
                {
                    attr: null,
                    values: [{ name: "web" }],
                },
                {
                    attr: null,
                    values: [{ name: "www.123.com" }],
                },
                {
                    attr: null,
                    values: [{ name: "192.169.23.54" }],
                },
            ],
            description: 'List all instances that include all the three keywords "web" "www.123.com" and "192.169.23.54"',
        },
        {
            type: "Single resource type",
            format: "[ResourceType]:[Keyword]",
            example: "IP:10.0.0.1",
            displayValue: [
                {
                    attr: {
                        key: "1",
                        type: "input",
                        name: "IP",
                    },
                    values: [{ name: "10.0.0.1" }],
                },
            ],
            description: 'List all instances whose "IP" is "10.0.0.1"',
        },
        {
            type: "Multiple resource types",
            format: "[ResourceType]:[Keyword][Enter↵][ResourceType]:[Keyword]",
            example: "Availability Zone:Hong Kong Zone 2 ↵ Project:Default",
            displayValue: [
                {
                    attr: {
                        key: "1",
                        type: "input",
                        name: "Availability Zone",
                    },
                    values: [{ name: "Hong Kong Zone 2" }],
                },
                {
                    attr: {
                        key: "2",
                        type: "input",
                        name: "Project",
                    },
                    values: [{ name: "Default" }],
                },
            ],
            description: 'List all instances whose "Availability Zone" is "Hong Kong Zone 2" and "Project" is "Default"',
        },
        {
            type: "Single resource type and multiple keywords",
            format: "[ResourceType]:[Keyword]|[Keyword]",
            example: "Status:Creating|Shutdown",
            displayValue: [
                {
                    attr: {
                        key: "1",
                        type: "input",
                        name: "Status",
                    },
                    values: [{ name: "Creating" }, { name: "Shutdown" }],
                },
            ],
            description: 'List all instances whose "Status" is "Creating" or "Shutdown"',
        },
        {
            type: "Pasted contents",
            format: "{Pasted contents}",
            example: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, "10.0.0.2"),
                react_1.default.createElement("p", null, "10.0.0.3"),
                react_1.default.createElement("p", null, "10.0.0.4"))),
            displayValue: [
                {
                    attr: null,
                    values: [
                        { name: "10.0.0.2" },
                        { name: "10.0.0.3" },
                        { name: "10.0.0.4" },
                    ],
                },
            ],
            description: 'List all instances include the keywords "10.0.0.2", "10.0.0.3" or "10.0.0.4"',
        },
    ],
};
var trans = { zh_CN: zh_CN, en_US: en_US };
var getColumns = function (lng) {
    var _a = trans[lng], columns = _a.columns, width = _a.width;
    return [
        {
            key: "type",
            header: columns.type,
            width: width.type,
            render: function (x) { return (react_1.default.createElement(text_1.Text, { theme: "label", style: { fontWeight: 700 } }, x.type)); },
        },
        {
            key: "format",
            header: columns.format,
            width: width.format,
            render: function (x) { return react_1.default.createElement(text_1.Text, { theme: "label" }, x.format); },
        },
        {
            key: "example",
            header: columns.example,
            width: width.example,
        },
        {
            key: "display",
            header: columns.displayValue,
            width: width.displayValue,
            render: function (x) { return (react_1.default.createElement(TagSearchBox_1.TagSearchBox, { value: x.displayValue, style: { pointerEvents: "none" } })); },
        },
        {
            key: "description",
            header: columns.description,
            width: width.description,
        },
    ];
};
var getRecords = function (lng) {
    var rows = trans[lng].rows;
    return rows;
};
function TagSearchBoxHelp() {
    var t = i18n_1.useTranslation();
    var _a = tslib_1.__read(react_1.useMemo(function () {
        var locale = t.locale === "zh_CN" ? "zh_CN" : "en_US";
        return [getColumns(locale), getRecords(locale)];
    }, [t.locale]), 2), columns = _a[0], records = _a[1];
    return (react_1.default.createElement(table_1.Table, { bordered: "all", disableTextOverflow: true, columns: columns, recordKey: "type", records: records }));
}
exports.TagSearchBoxHelp = TagSearchBoxHelp;
//# sourceMappingURL=TagSearchBoxHelp.js.map